import React, { PropsWithChildren } from 'react';
import { Modal } from 'react-bootstrap';
import BodyRegular from 'components/Typography/BodyRegular';

export default function DialogBody({
  children,
}: PropsWithChildren) {
  return (
    <Modal.Body className="dialog-body">
      <BodyRegular>
        {children}
      </BodyRegular>
    </Modal.Body>
  );
}
